import * as r from 'ramda';
import { call } from 'redux-saga/effects';

class RequestError extends Error {
  constructor(message, status, error) {
    super(message);
    this.status = parseInt(status);
    this.error = error;
    this.name = this.constructor.name;
  }
}

const handleStatuses = () => async (response) => {
  const { status } = response;

  if (200 <= status && status < 300) {
    return Promise.resolve(response);
  }

  const errorMessage = await getErrorMessage();
  return Promise.reject(new RequestError(errorMessage ?? 'Request error', status));

  async function getErrorMessage() {
    try {
      const { message } = await response.clone().json();
      return message;
    } catch {
      response.clone().text();
    }
  }
};

const handleErrors =
  ({ anyError, networkError, ...rest } = {}) =>
  (saga) =>
    function* (...args) {
      try {
        return yield call(saga, ...args);
      } catch (event) {
        let isErrorHandled = false;

        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line
          console.warn('Saga error: ', event);
        }

        if (event instanceof RequestError) {
          for (const key in rest) {
            const statuses = r.pipe(r.split(','), r.map(parseInt))(key);

            if (r.includes(event.status, statuses)) {
              yield call(rest[key], event.error, ...args);
              isErrorHandled = true;
            }
          }
        }

        if (networkError && event.message.indexOf('Network request failed') !== -1) {
          yield call(networkError, ...args);
          isErrorHandled = true;
        }

        if (anyError) {
          yield call(anyError, ...args);
          isErrorHandled = true;
        }

        if (isErrorHandled) {
          return event;
        }

        throw event;
      }
    };

export { RequestError, handleStatuses, handleErrors };
